import {AbilityBuilder} from '@casl/ability';
import {CommonAbility} from '../common-abilities';
import {PolicyIdentity} from './policy-account';

/**
 * Dynamic Resource Authorization Policies
 *
 * Tenant isolation is handled by defineGlobalPolicies.
 * No additional business constraints currently defined for DynamicResource domain.
 */
export function defineDynamicResourcePolicies(
  _identity: PolicyIdentity,
  _builder: AbilityBuilder<CommonAbility>
): void {
  // No business constraints — tenant isolation comes from defineGlobalPolicies
}
